import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import { colors } from '../../config/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateDownloadID,
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { useParams } from 'react-router-dom';
import MuiTable from '../../components/MuiTable/MuiTable';
import { Column } from '../../components/MuiTable/ViewData';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import qs from 'qs';
import { Role, SortOrderType } from '../../config/enum';
import { totalPages } from '../../config/helpers';
import { StateProps } from '../../redux/reducer';
import Button from '../../components/Button/Button';
import Dailog from '../../components/Dailog/Dailog';
import { successMessage } from '../../config/keyword';
import Filter from '../../components/Filter/Filter';

const columns: Column[] = [
  {
    id: 'weblinkUrl',
    label: 'Weblinks',
    minWidth: 600,
    align: 'left',
  },
  {
    id: 'categoryName',
    label: 'Category Name',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'categoryLable',
    label: 'Category Label',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'keywordText',
    label: 'Keyword',
    minWidth: 600,
    align: 'left',
  },

  {
    id: 'markForArchive',
    label: 'Archive',
    minWidth: 80,
    align: 'center',
  },
];

type ResultProps = {
  id: string;
  weblinkUrl: string;
  isDmcaGenerated: boolean;
  isArchive: boolean;
};

type ResponseProps = {
  createdBy: string;
  createdById: string;
  createdDate: string;
  documentStoreId: string;
  host: string;
  id: string;
  name: string;
  organizationId: string;
  sequenceNumber: number;
  siteUrl: string;
};

type RequestProps = {
  page: number;
  pageSize: number;
  searchText: string;
  sortBy: string;
  sortOrder: string;
  IsArchived: boolean | null;
};

type DmcaProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};

const DMCAFilesView = () => {
  const { id, userId } = useParams();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const [totalRowCount, setTotalRowCount] = useState<number>(0);
  const [dmcaFiles, setDmcaFiles] = useState<any>({});
  const [dmcaWebLinksFiles, setDmcaWebLinksFiles] = useState<any>({});
  const [isDeletePopup, setIsDeletePopup] = useState<boolean>(false);
  const [dialogLabel, setDialogLabel] = useState<string>('');
  const [confirmDailog, setConfirmDialog] = useState<string>('');
  const [requestState, setRequestState] = useState<RequestProps>({
    page: page,
    pageSize: limit,
    searchText: '',
    sortBy: '',
    sortOrder: SortOrderType.ASC,
    IsArchived: false,
  });
  const [filterLabel, setFilterLabel] = useState('Not Archived');
  const rootFilter = [
    {
      name: 'All',
      value: null,
    },
    {
      name: 'Archived',
      value: true,
    },
    {
      name: 'Not Archived',
      value: false,
    },
  ];
  const [notArchiveCount, setNotArchivedCount] = useState<any>(0);
  const filterColumns =
    userInfo.role === Role.User
      ? columns.filter((item) => item.id !== 'markForArchive')
      : columns;

  useEffect(() => {
    if (localStorage.getItem('isFrom') === 'users') {
      const breadcrumb = [
        { path: '/users', name: 'Users' },
        { path: `/userDetails/${userId}`, name: 'User Details' },
        { path: `/userActivity/${userId}`, name: 'User Activity' },
        { path: `/dmcaFilesView/${id}`, name: 'DMCA file details' },
      ];
      dispatch(update_breadcrumb(breadcrumb));
    } else if (localStorage.getItem('isFrom') === 'profile') {
      const breadcrumb = [
        { path: '/profile', name: 'Profile' },
        { path: `/userActivity/${userId}`, name: 'My Activity' },
        { path: `/dmcaFilesView/${id}`, name: 'DMCA file details' },
      ];
      dispatch(update_breadcrumb(breadcrumb));
    } else {
      const breadcrumb = [
        { path: '/dmcaFiles', name: 'DMCA Files' },
        { path: `/dmcaFilesView/${id}`, name: 'DMCA file details' },
      ];
      dispatch(update_breadcrumb(breadcrumb));
    }

    getDmcsFiles();
    getDmcaWebLinkFiles(requestState);
    return () => {
      // Your cleanup code here
      localStorage.removeItem('isFrom');
    };
  }, []);

  //Getting DMCS Files Details by ID
  const getDmcsFiles = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/dmca-files/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResponseProps) => {
    setDmcaFiles(data);
  };

  const getDmcaWebLinkFiles = async (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    await instance
      .get(`/dmca-files/${id}/weblinks?${queryString}`)
      .then((response) => {
        if (response.status === 200) {
          gotWebLinksResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotWebLinksResponse = (data: DmcaProps) => {
    setDmcaWebLinksFiles(data?.results as ResultProps[]);
    setTotalRowCount(data.totalCount);
    dispatch(updateIsLoading(false));

    setNotArchivedCount(
      data.results?.filter((item: ResultProps) => item.isArchive === false).length
    );
  };

  const weblinksAchived = async (row: any) => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`/weblinks/${row.id}/archive`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ARCHIVE_SUCCESS,
            type: flashBarTheme.SUCCESS,
          };
          getDmcsFiles();
          getDmcaWebLinkFiles(requestState);
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const weblinksArchivedAll = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`/dmca-files/${id}/weblinks/archive`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ARCHIVE_SUCCESS,
            type: flashBarTheme.SUCCESS,
          };
          getDmcsFiles();
          getDmcaWebLinkFiles(requestState);
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  //Pagination
  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getDmcaWebLinkFiles({ ...requestState, page: page, pageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getDmcaWebLinkFiles({
          ...requestState,
          page: page + 1,
          pageSize: limit,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getDmcaWebLinkFiles({
          ...requestState,
          page: page - 1,
          pageSize: limit,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getDmcaWebLinkFiles({
          ...requestState,
          page: 1,
          pageSize: limit,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getDmcaWebLinkFiles({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getDmcaWebLinkFiles({
        ...requestState,
        page: 1,
        pageSize: item,
      });
      setLimit(item);
      setPage(1);
    },
  };
  const downloadDMCAFile = () => {
    const obj = {
      isShow: true,
      downloadGuid: dmcaFiles.documentStoreId,
    };
    dispatch(updateDownloadID(obj));
  };

  const onSubmit = () => {
    if (confirmDailog === 'archive') {
      weblinksArchivedAll();
      setIsDeletePopup(false);
    }
  };
  const filterHandler = (row: any) => {
    getDmcaWebLinkFiles({
      ...requestState,
      page: page,
      pageSize: limit,
      IsArchived: row.value,
    });
    setRequestState({ ...requestState, IsArchived: row.value });
    setFilterLabel(row.name);
  };
  return (
    <>
      <div className="rounded-sm px-2">
        <PageHeading label="DMCA File Details" />
        <div className="bg-white mb-5 p-4 rounded-sm ">
          <div className={`flex flex-col justify-between ${colors.primaryText} `}>
            <div className="flex pb-2 flex-col md:flex-row">
              <div className="sm:w-1/3">Name</div>
              <div className="text-black flex sm:w-2/4">
                <div>{dmcaFiles?.name}</div>
              </div>
            </div>

            <div className="flex pb-2 flex-col md:flex-row">
              <div className="sm:w-1/3">SiteUrl</div>
              <div className="text-black flex sm:w-2/4">
                <div>{dmcaFiles?.siteUrl}</div>
              </div>
            </div>

            <div className="flex pb-2 flex-col md:flex-row">
              <div className="sm:w-1/3">CreatedDate</div>
              <div className="text-black flex sm:w-2/4">
                <div>{dmcaFiles.createdDate}</div>
              </div>
            </div>

            <div className="flex pb-2 flex-col md:flex-row">
              <div className="sm:w-1/3">Created By</div>
              <div className=" text-black flex sm:w-2/4">
                <div>{dmcaFiles.createdBy}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-end">
            <Button
              label="Download DMCA File"
              type="button"
              buttonType="primary"
              icon={<i className="fa-solid fa-cloud-arrow-down"></i>}
              onClick={() => downloadDMCAFile()}
            />
          </div>
        </div>
        <div className="bg-white mb-5 p-4 rounded-md ">
          {userInfo.role !== Role.User ? (
            <div
              className={`flex items-center justify-between border-b ${colors.primaryBorder} mb-2`}
            >
              <div className={`text-[#176b87] text-lg `}>Weblinks</div>
              <div className="flex items-center space-x-4 mb-2">
                <div>
                  {' '}
                  <Filter
                    filterHandler={filterHandler}
                    rootFilter={rootFilter}
                    label={filterLabel}
                    heading="Please Select"
                  />
                </div>
                {notArchiveCount > 0 && requestState.IsArchived === false && (
                  <div
                    className="w-[120px] flex items-center justify-center bg-yellow-400 px-4 font-semibold rounded-sm shadow-md cursor-pointer text-sm py-1"
                    onClick={() => {
                      setIsDeletePopup(true);
                      setConfirmDialog('archive');
                      setDialogLabel('Site Index');
                    }}
                  >
                    <div>Archive all</div>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          <MuiTable
            columns={filterColumns}
            rows={dmcaWebLinksFiles}
            onMarkForArchived={weblinksAchived}
            page={page}
            limit={limit}
            paginateHandler={paginateHandler}
            totalRowCount={totalRowCount}
          />
        </div>
      </div>

      <div className="flex justify-center pt-8">
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={dialogLabel}
          onConfirm={onSubmit}
          type={confirmDailog}
        />
      </div>
    </>
  );
};

export default DMCAFilesView;
